module.exports = __webpack_public_path__ + "images/7af51115a6d2437e4e76ae2557e1c0e7-golden_badge.png";